import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from "../../../components/dropdown/MultiSelectDropdown";

export const stdColdefs = [
    {
        field: "employeeName",
        headerName: "Employee Name",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "fixedSalary",
        headerName: "Fixed Salary",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "monthlySalary",
        headerName: "Monthly Salary",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "loanBalance",
        headerName: "Loan Balance",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "deductAmount",
        headerName: "Deduct Amount",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
    },
];

export const SalaryToBankTransferPopUp = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Employee basic details</span>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mt-[5px] mb-3">
                        <div className="input-outer-grp grid grid-cols-2 gap-2.5">
                            <div className="input-grp">
                                <label>Voucher no</label>
                                <TextInput type="number" id="voucherNo" name="voucherNo"
                                    //value={props.employeeBasicDetails.voucherNo} 
                                    value={props.employeeBasicDetails.idEmployeeSalary ? props.employeeBasicDetails.employeeSalaryNoList?.find(item => item.value === props.employeeBasicDetails.idEmployeeSalary)?.label : ""}
                                    //handleChange={(event) => props.handleChange(event, "voucherNo")}
                                    disabled
                                />
                            </div>
                            <div className="input-grp">
                                <label>Date</label>
                                <TextInput type="date" id="date" name="date" value={props.employeeBasicDetails.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Account head</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.accountheadList}
                                //value={props.employeeBasicDetails.idAccountHead}
                                value={props.employeeBasicDetails.idAccountHead ? props.employeeBasicDetails.accountheadList?.find(item => item.value === props.employeeBasicDetails.idAccountHead) : 0}
                                isDisabled={true}
                            // onChange={(event) =>
                            //     props.handleChange(
                            //         event,
                            //         "Account head"
                            //     )
                            // }
                            />
                        </div>
                        <div className="input-grp">
                            <label>Salary no</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.idEmployeeSalary !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.employeeSalaryNoList}
                                //value={props.employeeBasicDetails.idEmployeeSalary}
                                value={props.employeeBasicDetails.idEmployeeSalary ? props.employeeBasicDetails.employeeSalaryNoList?.find(item => item.value === props.employeeBasicDetails.idEmployeeSalary) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "idEmployeeSalary"
                                    )
                                }
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        <div className="input-outer-grp grid grid-cols-2 gap-2.5">
                            <div className="input-grp">
                                <label>From date</label>
                                <TextInput type="date" id="fromDate" name="fromDate" value={props.employeeBasicDetails.fromDate} handleChange={(event) => props.handleChange(event, "fromDate")} />
                            </div>
                            <div className="input-grp">
                                <label>To date</label>
                                <TextInput type="date" id="toDate" name="toDate" value={props.employeeBasicDetails.toDate} handleChange={(event) => props.handleChange(event, "toDate")} />
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Authorised by</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.authorisedBy !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.masterEmployeeList}
                                //value={props.employeeBasicDetails.authorisedBy}
                                value={props.employeeBasicDetails.authorisedBy ? props.employeeBasicDetails.masterEmployeeList?.find(item => item.value === props.employeeBasicDetails.authorisedBy) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "authorisedBy"
                                    )
                                }
                            />
                        </div>
                        <div className="input-grp">
                            <label>From account</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.fromAccountId !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.masterBankList}
                                //value={props.employeeBasicDetails.fromAccountId}
                                value={props.employeeBasicDetails.fromAccountId ? props.employeeBasicDetails.masterBankList?.find(item => item.value === props.employeeBasicDetails.fromAccountId) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "fromAccountId"
                                    )
                                }
                            />
                        </div>

                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Select series</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.employeeId !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.seriesList}
                                //value={props.employeeBasicDetails.idChequeBookMaster}
                                value={props.employeeBasicDetails.idChequeBookMaster ? props.employeeBasicDetails.seriesList?.find(item => item.value === props.employeeBasicDetails.idChequeBookMaster) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "idChequeBookMaster"
                                    )
                                }
                            />
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.idChequeBookDetails !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.chequeNoList}
                                value={props.employeeBasicDetails.idChequeBookDetails ? props.employeeBasicDetails.chequeNoList?.find(item => item.value === props.employeeBasicDetails.idChequeBookDetails) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "idChequeBookDetails"
                                    )
                                }
                            />
                        </div>
                        <div className="input-grp">
                            <label>Total cheque amount</label>
                            <TextInput type="number" id="totalSalaryAmount" name="totalSalaryAmount" value={props.employeeBasicDetails.totalSalaryAmount} handleChange={(event) => props.handleChange(event, "totalSalaryAmount")} />
                        </div>
                    </div>
                    <div className="ledger-table h-[40vh] pb-[12px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.employeeBasicDetails.stdRowData}
                                columnDefs={stdColdefs}
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">

                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        {/* <button className="update-btn btns">Save</button>
                        <button className="delete-btn btns">Clear</button> */}
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}